import { LoadUserProfilesDetailsTypes, LoadUserProfilesDetailsActions, UserDetailsListItem } from '../model/index';

export function userListDetails(userListDetails: UserDetailsListItem[]): LoadUserProfilesDetailsActions {
	return {
		type: LoadUserProfilesDetailsTypes.LOAD_USERS_PROFILES_DETAILS,
		payload: userListDetails,
	};
}
